import { ChevronRight, MessageCircle, Navigation } from "lucide-react";
import { MAPS_URL, SHOP_ADDRESS, whatsappUrl } from "@/lib/noleggio";
import { useI18n } from "@/lib/i18n";

export default function ShopContact({ prefix }) {
  const { t } = useI18n();
  return (
    <div className="flex gap-2 items-stretch min-w-0">
      <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-directions-button`}
        className="flex-1 min-w-0 flex items-center gap-3 min-h-[52px] px-3 rounded-2xl bg-[var(--brand-tertiary)] hover:bg-[var(--brand-secondary)] transition-colors">
        <span className="w-8 h-8 rounded-full bg-[var(--brand-primary)] flex items-center justify-center shrink-0">
          <Navigation size={15} color="#fff" />
        </span>
        <span className="flex-1 min-w-0">
          <span className="block text-sm font-bold text-[var(--brand-primary)]">{t("directions")}</span>
          <span className="block text-xs text-[var(--text-2)] truncate">{SHOP_ADDRESS}</span>
        </span>
        <ChevronRight size={18} className="text-[var(--muted)]" />
      </a>
      <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-whatsapp-button`}
        className="px-4 rounded-2xl bg-[#25D366] hover:opacity-90 transition-opacity text-white flex flex-col items-center justify-center gap-0.5">
        <MessageCircle size={20} />
        <span className="text-[11px] font-bold whitespace-nowrap">{t("whatsapp")}</span>
      </a>
    </div>
  );
}
